// import { apiFetch } from "../../lib/utils";

// export type NullReportingReviewStatus = 0 | 1 | 2 | 3; // Draft, Sent, Replied, Handled

// export interface CreateNullReportingReviewRequest {
//   supplierOrgNr: string;
//   period: string; // yyyy-MM
//   emailTemplateId?: number | null;
//   receiverMail: string;
//   emailSubject?: string | null;
//   emailBody?: string | null;
// }

// export interface UpdateNullReportingReviewDraftRequest {
//   emailTemplateId?: number | null;
//   receiverMail: string;
//   emailSubject?: string | null;
//   emailBody?: string | null;
// }

// export interface AddSupplierReplyRequest {
//   text: string;
// }

// export interface HandleNullReportingReviewRequest {
//   comment: string;
// }

// export interface NullReportingReviewSummaryRow {
//   supplierOrgNr: string;
//   totalCount: number;
//   openCount: number;
//   latestId: number;
//   latestStatus: NullReportingReviewStatus;
// }

// export interface NullReportingReviewDetailsResponse {
//   review: {
//     id: number;
//     supplierOrgNr: string;
//     supplierName?: string | null;
//     period: string;
//     status: NullReportingReviewStatus;
//     emailTemplateId?: number | null;
//     receiverMail: string;
//     emailSubject?: string | null;
//     emailBody?: string | null;
//     sentAt?: string | null;
//     supplierReplyText?: string | null;
//     supplierReplyAt?: string | null;
//     handledAt?: string | null;
//     handledComment?: string | null;
//     created: string;
//     createdBy: string;
//     updated: string;
//     updatedBy: string;
//   };
//   logs: Array<{
//     id: number;
//     status: number;
//     timestamp: string;
//     message: string;
//     comment?: string | null;
//   }>;
//   internalComments: Array<{
//     id: number;
//     text: string;
//     created: string;
//     createdBy: string;
//   }>;
// }

// const base = "/NullReporting/api/reviews";
// const jsonHeaders = { "Content-Type": "application/json" };

// export const NullReportingReviewsAPI = {
//   async createDraft(payload: CreateNullReportingReviewRequest): Promise<{ id: number }> {
//     const res = await apiFetch(`${base}`, "POST", JSON.stringify(payload), jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to create draft: ${res.statusText}`);
//     const data = await res.json();
//     return data; 
//   },

//   async updateDraft(id: number, payload: UpdateNullReportingReviewDraftRequest): Promise<{ message: string }> {
//     const res = await apiFetch(`${base}/${id}/draft`, "PUT", JSON.stringify(payload), jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to update draft: ${res.statusText}`);
//     return res.json();
//   },

//   async send(id: number): Promise<{ message: string; reviewId: number }> {
//     const res = await apiFetch(`${base}/${id}/send`, "POST", {}, jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to send review: ${res.statusText}`);
//     return res.json();
//   },

//   async addReply(id: number, payload: AddSupplierReplyRequest): Promise<{ message: string }> {
//     const res = await apiFetch(`${base}/${id}/reply`, "POST", JSON.stringify(payload), jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to add reply: ${res.statusText}`);
//     return res.json();
//   },

//   async handle(id: number, payload: HandleNullReportingReviewRequest): Promise<{ message: string }> {
//     const res = await apiFetch(`${base}/${id}/handle`, "POST", JSON.stringify(payload), jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to handle review: ${res.statusText}`);
//     return res.json();
//   },

//   async getById(id: number): Promise<NullReportingReviewDetailsResponse> {
//     const res = await apiFetch(`${base}/${id}`, "GET", {}, jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to get review: ${res.statusText}`);
//     return res.json();
//   },

//   async listBySupplierAndPeriod(
//     supplierOrgNr: string,
//     period: string
//   ): Promise<Array<{ id: number; status: number; receiverMail: string }>> {
//     const qs = new URLSearchParams({ supplierOrgNr, period });

//     const res = await apiFetch(`${base}?${qs.toString()}`, "GET", {}, jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to list reviews: ${res.statusText}`);
//     return res.json();
//   },

//   async summaryForPeriod(period: string): Promise<NullReportingReviewSummaryRow[]> {
//     const res = await apiFetch(`${base}/summary/${encodeURIComponent(period)}`, "GET", {}, jsonHeaders);
//     if (!res.ok) throw new Error(`Failed to load summary: ${res.statusText}`);
//     return res.json();
//   },
// };
import { apiFetch } from "../../lib/utils";

export type NullReportingReviewStatus = 0 | 1 | 2 | 3; // Draft, Sent, Replied, Handled
export type NullReportingReviewType = 0 | 1; // 0 = Email, 1 = Phone

export interface CreateNullReportingReviewRequest {
  supplierOrgNr: string;
  period: string; // yyyy-MM
  reviewType: NullReportingReviewType;

  // Email-only (nullable for Phone)
  emailTemplateId?: number | null;
  receiverMail?: string | null;
  emailSubject?: string | null;
  emailBody?: string | null;
}

export interface UpdateNullReportingReviewDraftRequest {
  // Email-only
  emailTemplateId?: number | null;
  receiverMail: string;
  emailSubject?: string | null;
  emailBody?: string | null;
}

export interface AddSupplierReplyRequest {
  text: string;
}

export interface HandleNullReportingReviewRequest {
  comment: string;
}

/** Phone attempt */
export interface AddPhoneAttemptRequest {
  attemptAt: string; // ISO string (local). Ex: new Date().toISOString() or "yyyy-MM-ddTHH:mm"
  contactName: string;
  notes?: string | null;
  outcome?: number | null; // tinyint on backend
}

export interface NullReportingPhoneAttemptRow {
  id: number;
  attemptAt: string;
  contactName: string;
  notes?: string | null;
  outcome?: number | null;
  created: string;
  createdBy: string;
}

export interface NullReportingReviewSummaryRow {
  supplierOrgNr: string;
  totalCount: number;
  openCount: number;
  latestId: number;
  latestStatus: NullReportingReviewStatus;
  latestType: NullReportingReviewType;
}

export interface NullReportingReviewDetailsResponse {
  review: {
    id: number;
    supplierOrgNr: string;
    supplierName?: string | null;
    period: string;
    status: NullReportingReviewStatus;
    reviewType: NullReportingReviewType;

    // Email fields (nullable for phone)
    emailTemplateId?: number | null;
    receiverMail?: string | null;
    emailSubject?: string | null;
    emailBody?: string | null;
    sentAt?: string | null;

    supplierReplyText?: string | null;
    supplierReplyAt?: string | null;

    handledAt?: string | null;
    handledComment?: string | null;

    created: string;
    createdBy: string;
    updated: string;
    updatedBy: string;
  };

  logs: Array<{
    id: number;
    status: number;
    timestamp: string;
    message: string;
    comment?: string | null;
  }>;

  internalComments: Array<{
    id: number;
    text: string;
    created: string;
    createdBy: string;
  }>;

  phoneAttempts: NullReportingPhoneAttemptRow[];
}

const base = "/NullReporting/api/reviews";
const jsonHeaders = { "Content-Type": "application/json" };

export const NullReportingReviewsAPI = {
  async createDraft(payload: CreateNullReportingReviewRequest): Promise<{ id: number }> {
    const res = await apiFetch(`${base}`, "POST", JSON.stringify(payload), jsonHeaders);
    if (!res.ok) throw new Error(`Failed to create draft: ${res.statusText}`);
    return res.json();
  },

  async updateDraft(id: number, payload: UpdateNullReportingReviewDraftRequest): Promise<{ message: string }> {
    const res = await apiFetch(`${base}/${id}/draft`, "PUT", JSON.stringify(payload), jsonHeaders);
    if (!res.ok) throw new Error(`Failed to update draft: ${res.statusText}`);
    return res.json();
  },

  async send(id: number): Promise<{ message: string; reviewId: number }> {
    const res = await apiFetch(`${base}/${id}/send`, "POST", {}, jsonHeaders);
    if (!res.ok) throw new Error(`Failed to send review: ${res.statusText}`);
    return res.json();
  },

  async addReply(id: number, payload: AddSupplierReplyRequest): Promise<{ message: string }> {
    const res = await apiFetch(`${base}/${id}/reply`, "POST", JSON.stringify(payload), jsonHeaders);
    if (!res.ok) throw new Error(`Failed to add reply: ${res.statusText}`);
    return res.json();
  },

  async handle(id: number, payload: HandleNullReportingReviewRequest): Promise<{ message: string }> {
    const res = await apiFetch(`${base}/${id}/handle`, "POST", JSON.stringify(payload), jsonHeaders);
    if (!res.ok) throw new Error(`Failed to handle review: ${res.statusText}`);
    return res.json();
  },

  async addPhoneAttempt(id: number, payload: AddPhoneAttemptRequest): Promise<{ message: string; attemptId: number }> {
    const res = await apiFetch(`${base}/${id}/phone-attempts`, "POST", JSON.stringify(payload), jsonHeaders);
    if (!res.ok) throw new Error(`Failed to add phone attempt: ${res.statusText}`);
    return res.json();
  },

  async getById(id: number): Promise<NullReportingReviewDetailsResponse> {
    const res = await apiFetch(`${base}/${id}`, "GET", {}, jsonHeaders);
    if (!res.ok) throw new Error(`Failed to get review: ${res.statusText}`);
    return res.json();
  },

  async listBySupplierAndPeriod(
    supplierOrgNr: string,
    period: string
  ): Promise<Array<{ id: number; status: number; reviewType: NullReportingReviewType; receiverMail?: string | null; created?: string }>> {
    const qs = new URLSearchParams({ supplierOrgNr, period });
    const res = await apiFetch(`${base}?${qs.toString()}`, "GET", {}, jsonHeaders);
    if (!res.ok) throw new Error(`Failed to list reviews: ${res.statusText}`);
    return res.json();
  },

  async summaryForPeriod(period: string): Promise<NullReportingReviewSummaryRow[]> {
    const res = await apiFetch(`${base}/summary/${encodeURIComponent(period)}`, "GET", {}, jsonHeaders);
    if (!res.ok) throw new Error(`Failed to load summary: ${res.statusText}`);
    return res.json();
  },
};
